// Google Analytics Configuration
// Replace with your actual GA4 Measurement ID from Google Analytics
// Format: G-XXXXXXXXXX
export const GOOGLE_ANALYTICS_CONFIG = {
  measurementId: process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-E27VWS7V6V',
  // Set to false in production to disable debug mode
  debugMode: process.env.NODE_ENV === 'development',
};
